import idx from 'idx';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { inviteCreative } from 'invite/ducks';
import Menu from 'explore/components/creative_menu';

export function mapStateToProps(state) {
  const isCreative = idx(state, _ => _.user.profile_data.is_creative) || false;
  const isClient = idx(state, _ => _.user.profile_data.is_client) || false;
  const hasOpenProjects = (idx(state, _ => _.user.profile_data.projects_owned_open) || 0) > 0;
  const isLoggedIn = state.user.logged_in;

  return {
    isCreative,
    isClient,
    isLoggedIn,
    hasOpenProjects
  };
}

export default withRouter(connect(mapStateToProps, {
  invite: inviteCreative
})(Menu));



// WEBPACK FOOTER //
// ./explore/containers/creative_menu.jsx